import React from "react";
import { ArrowLeft, Quote } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheJourneyToDeepTaste() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  return <section id="המסע-אל-הטעם-העמוק" className="dark bg-background text-foreground py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col gap-8 transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <header className="space-y-6">
              <span className="text-primary font-sans tracking-widest text-lg uppercase font-bold">
                הסיפור שלנו
              </span>
              <h2 className="text-4xl md:text-6xl font-serif font-medium leading-tight">מי אנחנו ומאיפה?</h2>
              <Separator className="bg-primary/30 w-24 h-1" />
            </header>

            <div className="prose prose-invert prose-lg max-w-none font-serif text-muted-foreground leading-relaxed">
              
              
              <p><br /><br />אנחנו מאשקלון. העסק נולד מתוך תשוקה אמיתית לעולם העישון והבשר, והתמחות בשיטת ה-Low &amp; Slow (עישון איטי של 12-14 שעות)&nbsp;<div><br /></div></p>
            </div>

            {}
            <div className="relative my-8 py-8 border-y border-border/50">
              <Quote className="absolute -top-5 right-8 text-primary fill-primary/20 w-10 h-10" />
              <blockquote className="text-2xl md:text-3xl font-serif text-primary italic text-center px-8 leading-normal">
                "אנחנו לא מאיצים בבשר. אנחנו נותנים לו את הזמן לספר את הסיפור שלו דרך העשן והאש."
              </blockquote>
            </div>

            <div className="prose prose-invert prose-lg max-w-none font-serif text-muted-foreground leading-relaxed">
              <p>קצת על העסק: ב"SMOKE&amp;GO" אנחנו לא רק מוכרים בשר, אלא חוויה. כל נתח (אסאדו, פיקניה, אונטריב ,דנבר וסינטה) נבחר בקפידה ומקבל טיפול ידני ומסור במעשנה. התוספות שלנו מתבשלות בכל יום בטריות ובאיכות תבלינים מוקפדים , הנזיד בוקרים שלנו הוא אותנטי פיקנטי נתחי קצבים מובחרים ימים ,אנטי פסטי במגוון ירקות טריים , האורז לבן כמובן קיימת אפשרות לטעמים , עשבי תיבול , שום קונפי, כורכום , פפריקה לטעמכם ובתאום , תוספות משונות תמיד יהיו מצורפות לטעימות .   המארזים שלנו תוכננו במיוחד למשפחות ולקבוצות (עד 5 נפשות למארז) ומציעים פתרון איכותי, משביע וללא צורך בהתעסקות או בציוד נוסף.</p>
              <p><br />זמינות: אנחנו פועלים לאורך כל השנה, בדגש על סופי שבוע וחגים, כשהאזור מתמלא במטיילים. מומלץ לתאם הזמנות מראש כדי להבטיח זמינות של נתחים ספציפיים.</p>
              <p><br />אופן השירות הוא טייק אוויי. נכון להיום, המודל שלנו מתמקד במארזי פיקניק יוקרתיים. הקונספט הוא לאפשר למטיילים "לקחת את המסעדה איתם" – המארזים שלנו מאובזרים לחלוטין, שומרים על חום, וכוללים את כל מה שמשפחה צריכה לארוחת שף בטבע (נתחי בשר מובחרים, תוספות חמות, רטבים וכלים).</p>
            </div>

            <div className="pt-6">
              <Button asChild size="lg" className="text-lg px-8 h-14 rounded-none">
                <Link to="/SmokedMenuPage">
                  גלו את התפריט שלנו
                  <ArrowLeft className="mr-2 w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 flex flex-col gap-6 sticky top-24 transition-all duration-1000 delay-300 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <figure className="relative group overflow-hidden">
              <div className="absolute inset-0 bg-primary/10 mix-blend-overlay z-10 pointer-events-none" />
              <img src="https://joint-labrador.10web.cloud/wp-content/uploads/2026/03/WhatsApp-Image-2026-02-25-at-23.39.38-1.jpeg" alt="תקריב של בשר במעשנה" className="w-full h-[500px] object-cover grayscale contrast-125 brightness-90 transition-transform duration-700 group-hover:scale-105" />
              <figcaption className="absolute bottom-0 right-0 bg-background/90 px-4 py-2 text-xs font-sans tracking-wider uppercase text-muted-foreground border-t border-l border-border">הקוסמת שלנו</figcaption>
            </figure>

            <figure className="relative group overflow-hidden mt-8 lg:-ml-12 shadow-2xl border-4 border-background">
              <div className="absolute inset-0 bg-primary/10 mix-blend-overlay z-10 pointer-events-none" />
              
              <figcaption className="absolute bottom-0 right-0 bg-background/90 px-4 py-2 text-xs font-sans tracking-wider uppercase text-muted-foreground border-t border-l border-border">
                דיוק בכל פרוסה
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>;
}